const toNumber = value => {
  const parsed = Number.parseFloat(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const round = (value, decimals = 2) => {
  const factor = 10 ** decimals;
  return Math.round((value + Number.EPSILON) * factor) / factor;
};

export const recalculateLineItem = (item, taxes = [], changedField = null) => {
  const quantity = Math.max(0, toNumber(item.quantity));
  const pricePerUnit = Math.max(0, toNumber(item.price_per_unit));
  const lineTotal = quantity * pricePerUnit;

  let discountMode = item._discount_mode;
  if (changedField === 'discount_amount') discountMode = 'amount';
  if (changedField === 'discount_percentage') discountMode = 'percentage';
  if (!discountMode) {
    discountMode = toNumber(item.discount_amount) > 0 && toNumber(item.discount_percentage) === 0
      ? 'amount'
      : 'percentage';
  }

  let discountPercentage;
  let discountAmount;
  if (discountMode === 'amount') {
    discountAmount = Math.min(Math.max(0, toNumber(item.discount_amount)), lineTotal);
    discountPercentage = lineTotal > 0 ? (discountAmount / lineTotal) * 100 : 0;
  } else {
    discountPercentage = Math.min(Math.max(0, toNumber(item.discount_percentage)), 100);
    discountAmount = lineTotal * discountPercentage / 100;
  }

  discountPercentage = round(discountPercentage, 4);
  discountAmount = round(discountAmount, 2);
  const taxableAmount = Math.max(0, lineTotal - discountAmount);
  const tax = taxes.find(candidate => candidate.id === item.tax_id);
  const taxPercentage = tax ? toNumber(tax.percentage) : 0;
  const taxAmount = round(taxableAmount * taxPercentage / 100, 2);

  return {
    ...item,
    _discount_mode: discountMode,
    discount_percentage: discountPercentage,
    discount_amount: discountAmount,
    tax_amount: taxAmount,
    total_amount: round(taxableAmount + taxAmount, 2),
  };
};
